export const BACKEND_URL = "https://apps.prosectra.com/api";
//export const BACKEND_URL = "https://app1.weboscy.com/api";
